import type { OrderDeliveryHistoryEntryType } from "@sellar-io/api-v2/types";
import { historyDate } from "./deliveryHistoryDates";

type ScheduledEntry = Extract<
  OrderDeliveryHistoryEntryType,
  { type: "scheduled" }
>;

export function scheduleChangeLabel({
  stage,
  previousDate,
  scheduledDate,
}: Pick<ScheduledEntry, "stage"> & {
  previousDate: Date | string | null;
  scheduledDate: Date | string | null;
}) {
  const stageName = {
    collection: "Collection",
    palletReceipt: "Pallet arrival",
    delivery: "Delivery",
  }[stage];
  if (!scheduledDate) {
    return `${stageName} booking removed`;
  }
  if (previousDate) {
    return `${stageName} rescheduled from ${historyDate(new Date(previousDate))} to ${historyDate(new Date(scheduledDate))}`;
  }
  return `${stageName} scheduled for ${historyDate(new Date(scheduledDate))}`;
}
